/**
 * Web color names the teams are named after, with their hex values. Kept to
 * colors that read as distinct from one another on a swatch.
 */
export const TEAM_COLORS: readonly { name: string; hex: string }[] = [
  { name: 'Coral', hex: '#FF7F50' },
  { name: 'Tomato', hex: '#FF6347' },
  { name: 'Crimson', hex: '#DC143C' },
  { name: 'Firebrick', hex: '#B22222' },
  { name: 'Hot Pink', hex: '#FF69B4' },
  { name: 'Deep Pink', hex: '#FF1493' },
  { name: 'Orchid', hex: '#DA70D6' },
  { name: 'Plum', hex: '#DDA0DD' },
  { name: 'Medium Purple', hex: '#9370DB' },
  { name: 'Rebecca Purple', hex: '#663399' },
  { name: 'Indigo', hex: '#4B0082' },
  { name: 'Slate Blue', hex: '#6A5ACD' },
  { name: 'Royal Blue', hex: '#4169E1' },
  { name: 'Dodger Blue', hex: '#1E90FF' },
  { name: 'Deep Sky Blue', hex: '#00BFFF' },
  { name: 'Steel Blue', hex: '#4682B4' },
  { name: 'Teal', hex: '#008080' },
  { name: 'Turquoise', hex: '#40E0D0' },
  { name: 'Aquamarine', hex: '#7FFFD4' },
  { name: 'Sea Green', hex: '#2E8B57' },
  { name: 'Lime Green', hex: '#32CD32' },
  { name: 'Chartreuse', hex: '#7FFF00' },
  { name: 'Olive Drab', hex: '#6B8E23' },
  { name: 'Gold', hex: '#FFD700' },
  { name: 'Goldenrod', hex: '#DAA520' },
  { name: 'Dark Orange', hex: '#FF8C00' },
  { name: 'Chocolate', hex: '#D2691E' },
  { name: 'Sienna', hex: '#A0522D' },
  { name: 'Salmon', hex: '#FA8072' },
  { name: 'Khaki', hex: '#F0E68C' },
]
